export const DATE_FORMAT_CONFIG = {
  'DD/MM/YYYY': { label: 'DD/MM/YYYY' },
  'MM/DD/YYYY': { label: 'MM/DD/YYYY' },
  'YYYY-MM-DD': { label: 'YYYY-MM-DD' },
} as const;

export type OrgDateFormat = keyof typeof DATE_FORMAT_CONFIG;

export const SUPPORTED_DATE_FORMATS = Object.keys(DATE_FORMAT_CONFIG) as OrgDateFormat[];

export const DEFAULT_DATE_FORMAT: OrgDateFormat = 'DD/MM/YYYY';

export const TIME_FORMAT_CONFIG = {
  '12h': { label: '12-hour (AM/PM)' },
  '24h': { label: '24-hour' },
} as const;

export type OrgTimeFormat = keyof typeof TIME_FORMAT_CONFIG;

export const SUPPORTED_TIME_FORMATS = Object.keys(TIME_FORMAT_CONFIG) as OrgTimeFormat[];

export const DEFAULT_TIME_FORMAT: OrgTimeFormat = '24h';

export type DateFormatPreset =
  | 'date'
  | 'dateTime'
  | 'time'
  | 'monthYear'
  | 'longDate'
  | 'filename';

export const resolveDateFormat = (value?: string | null): OrgDateFormat => {
  if (value && value in DATE_FORMAT_CONFIG) {
    return value as OrgDateFormat;
  }
  return DEFAULT_DATE_FORMAT;
};

export const resolveTimeFormat = (value?: string | null): OrgTimeFormat => {
  if (value && value in TIME_FORMAT_CONFIG) {
    return value as OrgTimeFormat;
  }
  return DEFAULT_TIME_FORMAT;
};

const DATE_PATTERNS: Record<OrgDateFormat, Record<'date' | 'longDate' | 'filename' | 'monthYear', string>> = {
  'DD/MM/YYYY': {
    date: 'dd/MM/yyyy',
    longDate: 'EEEE, dd/MM/yyyy',
    filename: 'dd_MM_yyyy',
    monthYear: 'MM/yyyy',
  },
  'MM/DD/YYYY': {
    date: 'MM/dd/yyyy',
    longDate: 'EEEE, MM/dd/yyyy',
    filename: 'MM_dd_yyyy',
    monthYear: 'MM/yyyy',
  },
  'YYYY-MM-DD': {
    date: 'yyyy-MM-dd',
    longDate: 'EEEE, yyyy-MM-dd',
    filename: 'yyyy_MM_dd',
    monthYear: 'yyyy-MM',
  },
};

const TIME_PATTERNS: Record<OrgTimeFormat, string> = {
  '12h': 'h:mm a',
  '24h': 'HH:mm',
};

export const getDateFnsPattern = (
  preset: DateFormatPreset,
  dateFormat: OrgDateFormat,
  timeFormat: OrgTimeFormat
): string => {
  const datePatterns = DATE_PATTERNS[dateFormat];

  switch (preset) {
    case 'date':
      return datePatterns.date;
    case 'longDate':
      return datePatterns.longDate;
    case 'filename':
      return datePatterns.filename;
    case 'monthYear':
      return datePatterns.monthYear;
    case 'time':
      return TIME_PATTERNS[timeFormat];
    case 'dateTime':
      return `${datePatterns.date} ${TIME_PATTERNS[timeFormat]}`;
    default:
      return datePatterns.date;
  }
};
